/**
 * @generated SignedSource<<a6f7e2dd7d5982a31fd93d6d118df456>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatorsContent_viewer$data = {
  readonly groupedCreators: ReadonlyArray<{
    readonly groupName: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"CreatorsGroup_creatorGroup" | "CreatorsLetterSelector_creatorGroups">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"CreatorsTopCreators_viewer">;
  readonly " $fragmentType": "CreatorsContent_viewer";
};
export type CreatorsContent_viewer$key = {
  readonly " $data"?: CreatorsContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreatorsContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "nationality"
    },
    {
      "kind": "RootArgument",
      "name": "style"
    },
    {
      "kind": "RootArgument",
      "name": "vertical"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreatorsContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreatorsTopCreators_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "nationality",
          "variableName": "nationality"
        },
        {
          "kind": "Variable",
          "name": "style",
          "variableName": "style"
        },
        {
          "kind": "Variable",
          "name": "vertical",
          "variableName": "vertical"
        }
      ],
      "concreteType": "CreatorGroup",
      "kind": "LinkedField",
      "name": "groupedCreators",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "groupName",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CreatorsGroup_creatorGroup"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CreatorsLetterSelector_creatorGroups"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0fdd35c37c11707d66836b99eab2cb51";

export default node;
